module.exports = __webpack_public_path__ + "assets/welcome-illustration.0f8d4064.svg";